var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_883_910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8908 57.1427C29.4418 57.6937 30.177 58 30.9116 58C31.6462 58 32.3813 57.6937 32.9323 57.1427L41.444 48.5085C42.546 47.4065 42.546 45.5693 41.444 44.4669C40.342 43.3649 38.5048 43.3649 37.4024 44.4669L33.7281 48.2633L33.7281 45.0179L33.7285 37.7924C33.7285 36.2004 32.4423 34.9753 30.9115 34.9753L30.8504 34.9753C29.2584 34.9753 28.0334 36.2615 28.0334 37.7924L28.0334 47.8353L27.666 47.7743L24.4817 44.5899C23.4407 43.6101 21.8488 43.3653 20.6852 44.1611C19.2155 45.202 19.0932 47.284 20.3179 48.509L28.8908 57.1427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9262 30.6892C53.8651 29.5872 53.8036 28.4847 53.6814 27.3827C52.8852 19.5447 46.6396 13.115 38.8625 12.1352C30.4735 11.0943 23.0639 16.1768 20.492 23.4637C20.1858 23.4637 19.8184 23.4026 19.5122 23.4026C13.205 23.4026 8 28.5462 8 34.8536V37.7316C8 39.3236 9.34717 40.5486 10.9392 40.5486H11.0002C12.5311 40.5486 13.7557 39.2015 13.7557 37.6706V35.405C13.4495 31.976 16.2049 29.0978 19.5119 29.0978H20.0019H22.2063C23.4925 29.2204 24.7171 28.6689 25.1455 27.3832L25.758 25.6076C27.2889 21.3213 31.0853 18.0758 35.6168 17.647C42.6586 17.0344 48.7211 22.9743 48.2313 29.9552V37.9159C48.2923 39.3856 49.6395 40.6103 51.1704 40.6103H51.2315C52.7012 40.6103 53.8644 39.3857 53.987 37.9159L53.9262 30.6892Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_883_910",
    x: 0,
    y: 0,
    width: 65.9873,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.494118 0 0 0 0 0.490196 0 0 0 0 0.490196 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_883_910"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.495833 0 0 0 0 0.491701 0 0 0 0 0.491701 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_883_910",
    result: "effect2_dropShadow_883_910"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_883_910",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.474b5ba7f8130a9996ed428ce528d7a7.svg";
export { ForwardRef as ReactComponent };